import { Directive, inject, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthService } from '../auth/auth.service';

@Directive({
    standalone: true,
    selector: '[hasClaim]'
})
export class HasClaimDirective {
    private claimName: string[] = [];

    private readonly templateRef = inject(TemplateRef<any>);
    private readonly viewContainer = inject(ViewContainerRef);
    private readonly authService = inject(AuthService);

    @Input()
    set hasClaim(claims: string[]) {
        if (claims.length > 0) {
            this.claimName = claims;
            this.checkPermission();
        } else this.viewContainer.createEmbeddedView(this.templateRef);
    }

    private async checkPermission() {
        this.viewContainer.clear();

        try {
            // 👇 Espera los datos del usuario (puede venir de un observable, API o cache)
            const user = await this.authService.returnUserInfo();
            const isSuperAdmin = Number((user as any)?.superadmin) === 1;
            const hasClaim = isSuperAdmin || user?.claims?.some((c) => this.claimName.includes(c.nombre));

            if (hasClaim) {
                this.viewContainer.createEmbeddedView(this.templateRef);
            }
        } catch (err) {
            console.error('Error verificando claims:', err);
        }
    }
}
